export const isOnlineRafflePayment = method => ["card", "stripe", "paypal"].includes((method || "").toLowerCase());
export const isOfflineRafflePayment = method => ["cash", "check", "cod"].includes((method || "").toLowerCase());